module.exports = __webpack_public_path__ + "static/k-8e0fa1e0312ffbfca3ee26da4e08f5be.png";